import * as yup from "yup";
import { ContentBlockData, ContentBlockSchema } from "./";
import { ReactSelectOptionSchema } from "../generic";
import * as M from "../../models";

export const LINK_TYPE_PAGE = 0;
export const LINK_TYPE_URL = 1;
export const THUMBNAIL_TYPE_IMAGE = 0;
export const THUMBNAIL_TYPE_ICON = 1;

export interface ContentLinkListData extends ContentBlockData {
    links: ContentLinkData[];
    promptThumbnail: boolean;
    title?: string;
}

export interface ContentLinkData {
    deleted: boolean;
    icon?: string;
    iconImage?: string;
    id: number;
    index: number;
    linksToNav?: M.Generic.ReactSelectOption | M.AdminNav.NavListItem | null;
    linksToUrl?: string;
    linkType: number;
    promptThumbnail: boolean;
    sort: number;
    thumbnailType: number;
    title: string;
}

export const ContentLinkListSchema = yup.object().shape({
    links: yup.array().of(yup.object<ContentLinkData>().shape({
        deleted: yup.bool(),
        icon: yup.string().when(["deleted", "thumbnailType", "promptThumbnail"], (deleted: boolean, thumbnailType: number, promptThumbnail: boolean) => {
            return !deleted && promptThumbnail && thumbnailType === THUMBNAIL_TYPE_ICON
                ? yup.string().required().max(50).label("Link icon")
                : yup.string();
        }),
        iconImage: yup.string().when(["deleted", "thumbnailType", "promptThumbnail"], (deleted: boolean, thumbnailType: number, promptThumbnail: boolean) => {
            return !deleted && promptThumbnail && thumbnailType === THUMBNAIL_TYPE_IMAGE
                ? yup.string().required().max(255).label("Link thumbnail")
                : yup.string();
        }),
        id: yup.number().when("deleted", { is: false, then: yup.number().required() }),
        index: yup.number(),
        linksToNav: ReactSelectOptionSchema.when(["deleted", "linkType"], (deleted: boolean, linkType: number) => {
            return !deleted && linkType === LINK_TYPE_PAGE
                ? ReactSelectOptionSchema.required().label("Link to page")
                : ReactSelectOptionSchema;
        }).label("Link to page"),
        linksToUrl: yup.string().when(["deleted", "linkType"], (deleted: boolean, linkType: number) => {
            return !deleted && linkType === LINK_TYPE_URL
                ? yup.string().required().max(255).label("Link URL")
                : yup.string();
        }),
        linkType: yup.number().when("deleted", { is: false, then: yup.number().required().min(0).max(1) }).label("Link type"),
        promptThumbnail: yup.bool(),
        sort: yup.number().when("deleted", { is: false, then: yup.number().required().min(1) }),
        title: yup.string().when("deleted", { is: false, then: yup.string().required().max(255) }).label("Link title"),
        thumbnailType: yup.number().when("deleted", { is: false, then: yup.number().required().min(0).max(1) }).label("Link thumbnail type"),
    })),
    promptThumbnail: yup.bool(),
    title: yup.string().max(255),
}).concat(ContentBlockSchema);

// yup.object<ContentLinkData>().shape({
//     deleted: yup.bool(),
//     icon: yup.string(),
//     iconImage: yup.string(),
//     id: yup.number(),
//     index: yup.number(),
//     linksToNav: ReactSelectOptionSchema,
//     linksToUrl: yup.string(),
//     linkType: yup.number(),
//     promptThumbnail: yup.bool(),
//     sort: yup.number(),
//     title: yup.string(),
//     thumbnailType: yup.number(),
// })



// WEBPACK FOOTER //
// ./src/forms/adminPage/ContentLinkList.ts